import type {ThemePreset} from '@/types';

export const THEME_PRESET_STORAGE_KEY = 'canvas-theme-preset';

export type {ThemePreset};

export const THEME_PRESETS: {value: ThemePreset; label: string}[] = [
	{value: 'light', label: 'Светлая'},
	{value: 'dark', label: 'Тёмная'},
	{value: 'blue', label: 'Синяя'},
];

const DEFAULT_PRESET: ThemePreset = 'blue';

export function getThemePreset(): ThemePreset {
	if (typeof window === 'undefined') return DEFAULT_PRESET;
	const stored = window.localStorage.getItem(THEME_PRESET_STORAGE_KEY);
	if (stored === 'light' || stored === 'dark' || stored === 'blue') return stored;
	return DEFAULT_PRESET;
}

export function setThemePreset(value: ThemePreset): void {
	window.localStorage.setItem(THEME_PRESET_STORAGE_KEY, value);
}
